const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns all available loots.
 */
function fetchOffers(apiUrl, { country, platform } = {}) {
  return fetchJsonApi({
    method: 'GET',
    apiUrl,
    endpoint: 'v1/offers',
    query: { country, platform, lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching offers',
  });
}

function fetchTicketOffers(apiUrl, { country } = {}) {
  return fetchJsonApi({
    method: 'GET',
    apiUrl,
    endpoint: 'v2/ticketOffers',
    query: { country },
    expectedStatus: 200,
    description: 'Fetching ticket offers',
  });
}

function purchaseTickets(apiUrl, token, ticketOfferId, paymentDetails) {
  return fetchAuthorizedJsonApi({
    method: 'POST',
    apiUrl,
    endpoint: `v1/ticketOffers/${ticketOfferId}/purchase`,
    token,
    body: paymentDetails,
    description: 'Creating ticket purchase',
    expectedStatus: 200,
  });
}

function fetchOffersTaken(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    method: 'GET',
    apiUrl,
    endpoint: 'v1/offers/taken',
    query: { lang: getApiLanguage() },
    token,
    expectedStatus: 200,
    description: 'Fetching taken offers',
  });
}

function takeUpOnOffer(apiUrl, token, offerId) {
  return fetchAuthorizedJsonApi({
    method: 'PUT',
    apiUrl,
    endpoint: `v1/offers/${offerId}`,
    query: { lang: getApiLanguage() },
    token,
    expectedStatus: 200,
    description: 'Taking up on offer',
  });
}

module.exports = {
  fetchOffers,
  fetchOffersTaken,
  takeUpOnOffer,
  fetchTicketOffers,
  purchaseTickets,
};
